// SPORT part
export const MEMBERSHIP_CURRENT_LOADING = 'MEMBERSHIP_CURRENT_LOADING';
export const MEMBERSHIP_CURRENT_SUCCESS = 'MEMBERSHIP_CURRENT_SUCCESS';
export const MEMBERSHIP_CURRENT_ERROR = 'MEMBERSHIP_CURRENT_ERROR';

export const MEMBERSHIP_INFO_LOADING = 'MEMBERSHIP_INFO_LOADING';
export const MEMBERSHIP_INFO_SUCCESS = 'MEMBERSHIP_INFO_SUCCESS';
export const MEMBERSHIP_INFO_ERROR = 'MEMBERSHIP_INFO_ERROR';